import Big from 'big.js'
import { Token, TokenWithBalances } from 'src/common/types/models/Tokens'
import InfiniteList from 'src/common/ui-kit/InfiniteList/InfiniteList'
import Skeleton from 'src/common/ui-kit/Skeleton/Skeleton'
import { calcRatio } from '../../utils'
import AssetRow from './AssetRow'
import AssetsNoResults from './AssetNoResults'
import TokenInfo from 'src/common/components/ TokenInfo/ TokenInfo'
import { useState } from 'react'
import useToggle from 'src/common/hooks/helpers/useToggle'
import CarbonBundleDepositModal from 'src/common/components/CarbonBundle/Deposit/CarbonBundleDepositModal'
import CarbonBundleWithdrawModal from 'src/common/components/CarbonBundle/Withdraw/CarbonBundleWithdrawModal'

interface AssetListProps {
  assets: TokenWithBalances[]
  totalBalanceInUsd: Big
}

const AssetList: React.FC<AssetListProps> = ({ assets, totalBalanceInUsd }) => {
  const skeletonCount = assets.length === 0 ? 10 : 2

  const [infoToken, setInfoToken] = useState<Token | null>(null)

  const {
    isOn: isDepositOpen,
    on: openDeposit,
    off: closeDeposit,
  } = useToggle()

  const {
    isOn: isWithdrawOpen,
    on: openWithdraw,
    off: closeWithdraw,
  } = useToggle()

  const {
    isOn: isInfoModalOpen,
    on: openInfoModal,
    off: closeInfoModal,
  } = useToggle()

  const onInfo = (token: Token) => {
    setInfoToken(token)
    openInfoModal()
  }

  const onAddToBundle = openDeposit
  const onWithdrawFromBundle = openWithdraw

  return (
    <div>
      <div className='space-y-2'>
        <InfiniteList
          loader={<Skeleton height={60} count={skeletonCount} />}
          noResults={<AssetsNoResults />}
        >
          {assets.map(asset => (
            <AssetRow
              key={asset.id}
              asset={asset}
              ratio={calcRatio(asset.usdBalance, totalBalanceInUsd)}
              onInfo={onInfo}
              onAddToBundle={onAddToBundle}
              onWithdrawFromBundle={onWithdrawFromBundle}
              onTrade={() => {}}
            />
          ))}
        </InfiniteList>
      </div>

      <CarbonBundleDepositModal open={isDepositOpen} onClose={closeDeposit} />

      <CarbonBundleWithdrawModal
        open={isWithdrawOpen}
        onClose={closeWithdraw}
      />

      <TokenInfo
        token={infoToken}
        isOpen={isInfoModalOpen}
        onClose={closeInfoModal}
      />
    </div>
  )
}

export default AssetList
